'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _AppConstants = require('../../../constants/AppConstants');

var _AppConstants2 = _interopRequireDefault(_AppConstants);

var _FormManager = require('../../../lib/mighty-fields/FormManager');

var _FormManager2 = _interopRequireDefault(_FormManager);

var _MedicalCodesFormGroup = require('../MedicalCodesFormGroup');

var _MedicalCodesFormGroup2 = _interopRequireDefault(_MedicalCodesFormGroup);

var _common = require('../../../lib/mighty-fields/common');

var _mightyFields = require('../../../lib/mighty-fields');

var _commonFormsy = require('../../common-formsy');

var _util = require('../../../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LIEN_MODELS = _AppConstants2.default.LIEN_MODELS;
var NewMedicalFundingModal = (_dec = (0, _mobxReact.inject)('FunderStore', 'LienStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(NewMedicalFundingModal, _Component);

  function NewMedicalFundingModal(props) {
    _classCallCheck(this, NewMedicalFundingModal);

    var _this = _possibleConstructorReturn(this, (NewMedicalFundingModal.__proto__ || Object.getPrototypeOf(NewMedicalFundingModal)).call(this, props));

    _initDefineProp(_this, 'codes', _descriptor, _this);

    _this.formManager = new _FormManager2.default({
      fieldSets: _this.fieldSets,
      onSave: _this.onSave,
      onSuccess: props.onClose
    });
    return _this;
  }

  _createClass(NewMedicalFundingModal, [{
    key: 'onSave',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _props, LienStore, _case;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, LienStore = _props.LienStore, _case = _props._case;
                _context.next = 3;
                return LienStore.upsert(_extends({}, data, {
                  case: _case.id,
                  codes: (0, _mobx.toJS)(this.codes),
                  is_confirmed: true
                }), LIEN_MODELS.MEDICAL.key);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSave(_x) {
        return _ref.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: 'addCode',
    value: function addCode(code) {
      this.codes = code;
    }
  }, {
    key: 'removeCode',
    value: function removeCode(code) {
      this.codes = this.codes.filter(function (medicalCode) {
        return !(0, _isEqual3.default)((0, _mobx.toJS)(code), medicalCode);
      });
    }
  }, {
    key: 'submit',
    value: function submit() {
      var form = this.formManager.refForm;
      form && form.submit();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Modal2.default,
        { className: 'modal-new-medical-funding', show: true, onHide: this.props.onClose },
        _react2.default.createElement(
          _Modal2.default.Header,
          { closeButton: true },
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            'New Medical Lien'
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          _react2.default.createElement(
            _Grid2.default,
            { fluid: true },
            _react2.default.createElement(
              _commonFormsy.Form,
              _extends({ ref: this.setRefForm }, this.formManager.formProps),
              _react2.default.createElement(_mightyFields.FormFieldSets, _extends({
                fieldSets: this.fieldSets
              }, this.formManager.formGroupsProps)),
              _react2.default.createElement(_Button2.default, {
                type: 'submit',
                className: 'hidden',
                disabled: this.formManager.submitDisabled()
              })
            ),
            _react2.default.createElement(_MedicalCodesFormGroup2.default, {
              deleteMedicalCode: this.removeCode,
              onSubmit: this.addCode,
              medicalCodes: this.codes
            }),
            this.formManager.errorMessages.map(function (error) {
              return _react2.default.createElement(
                _Row2.default,
                { className: 'text-danger', key: error.field },
                _react2.default.createElement(
                  'strong',
                  null,
                  error.field
                ),
                ' - ',
                error.message
              );
            })
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Footer,
          null,
          _react2.default.createElement(
            _ButtonToolbar2.default,
            { className: 'pull-right' },
            _react2.default.createElement(
              _Button2.default,
              { onClick: this.props.onClose },
              'Cancel'
            ),
            _react2.default.createElement(
              _Button2.default,
              {
                type: 'submit',
                onClick: this.submit,
                bsStyle: 'primary',
                disabled: this.formManager.submitDisabled()
              },
              this.formManager.isSubmitting ? 'Saving...' : 'Save'
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'fieldSets',
    get: function get() {
      var _props$FunderStore = this.props.FunderStore,
          isFinanceCustomer = _props$FunderStore.isFinanceCustomer,
          isMedicalProvider = _props$FunderStore.isMedicalProvider,
          purchaseDateFieldSet = {
        editProps: { positionRight: true },
        field: 'purchase_date',
        required: true,
        type: 'date'
      };


      return (0, _common.fillInFieldSets)([[{ field: 'label', required: true }], [{ field: 'initial_service_date', required: true, type: 'date' }, { field: 'end_service_date', type: 'date' }].concat(_toConsumableArray((0, _util.insertIf)(!isMedicalProvider, purchaseDateFieldSet)), [{ field: 'notes', type: 'text' }], _toConsumableArray((0, _util.insertIf)(isFinanceCustomer, { field: 'is_available_to_coop', label: 'Available To CoOp Capital', required: true, type: 'boolean' })))]);
    }
  }]);

  return NewMedicalFundingModal;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  LienStore: _propTypes2.default.object.isRequired,
  onClose: _propTypes2.default.func.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'codes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
})), _class2)) || _class) || _class) || _class);
var _default = NewMedicalFundingModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LIEN_MODELS, 'LIEN_MODELS', '/app/src/components/page-case/main-fundings/NewMedicalFundingModal.js');
  reactHotLoader.register(NewMedicalFundingModal, 'NewMedicalFundingModal', '/app/src/components/page-case/main-fundings/NewMedicalFundingModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-fundings/NewMedicalFundingModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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